import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollResetPathKey } from '../utils/buildRoutes';

/** Reset the app scroll container when the route pathname changes. */
export default function ScrollToTop({ scrollRootRef }) {
    const { pathname } = useLocation();
    const scrollKey = scrollResetPathKey(pathname);

    useEffect(() => {
        const el = scrollRootRef?.current;
        if (!el) return;
        el.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [scrollKey, scrollRootRef]);

    return null;
}
